import { IListItem, INote } from "../../../../shared/type/list.type";
import { cn } from "../../../../util/base.util";

export function ListItem({item, check}: {
    item: IListItem;
    check: (id: number) => void;
}) {
    return (
        <div onClick={() => {
            check(item.id);
        }} className="flex items-center gap-2 p-2">
            <div>
                <input readOnly type="checkbox" checked={item.isChecked} className="checkbox checkbox-sm" />
            </div>
            <div className="flex-1 cursor-pointer">
                <p className={cn(
                    item.isChecked && "line-through opacity-50"
                )}>{item.label}</p>
            </div>
        </div>
    );
}

export default function List({note}: {
    note: INote;
}) {
    return null;
}